import { render } from "./RequestPasswordChange.vue?vue&type=template&id=c35ed1d2"
import script from "./RequestPasswordChange.vue?vue&type=script&lang=js"
export * from "./RequestPasswordChange.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__